var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenubarIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.803 4.625H2.82165C1.95017 4.625 1.2373 5.21506 1.2373 5.93612V8.86388C1.2373 9.58492 1.95017 10.175 2.82165 10.175H34.803C35.6743 10.175 36.3873 9.58494 36.3873 8.86388V5.93612C36.3873 5.21508 35.6743 4.625 34.803 4.625Z",
    fill: "#2F4156"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.803 14.8H2.82165C1.95017 14.8 1.2373 15.3901 1.2373 16.1112V19.0389C1.2373 19.7601 1.95017 20.35 2.82165 20.35H34.803C35.6743 20.35 36.3873 19.7601 36.3873 19.0389V16.1112C36.3873 15.3901 35.6743 14.8 34.803 14.8Z",
    fill: "#2F4156"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.803 25.8999H2.82165C1.95017 25.8999 1.2373 26.49 1.2373 27.2111V30.1388C1.2373 30.86 1.95017 31.4499 2.82165 31.4499H34.803C35.6743 31.4499 36.3873 30.86 36.3873 30.1388V27.2111C36.3873 26.49 35.6743 25.8999 34.803 25.8999Z",
    fill: "#2F4156"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenubarIcon);
export default __webpack_public_path__ + "static/media/MenubarIcon.be46d2a8babc5efdb484271e49bede7b.svg";
export { ForwardRef as ReactComponent };